import React from 'react'
import './auth.styles.scss'

const AuthTemplate = (props) => {
    return (
        <div className="auth">
            <header>
                <h1><br/>Epicescape Tour - Admin</h1>
            </header>
            {props.children}
            <footer>
                <ul>
                    <li>
                        <a rel="noopener noreferrer" href="https://epicescapetour.com" >Main Site</a>
                    </li>
                </ul>
                <p>© 2026 Epicescape Tour. All rights reserved.</p>
            </footer>
        </div>
    )
}

export default AuthTemplate